export class FeatureTogglesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFeatureToggles() {
    return this.#http.get('/FeatureToggles');
  }
}
